// Instância Axios dedicada à API externa de autenticação (login, logout, verificação de token).Cada requisição autenticada recebe automaticamente
// o header Authorization: Bearer {token}, lido do localStorage.

import axios from 'axios';

const authApi = axios.create({
  baseURL: process.env.REACT_APP_AUTH_API_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json'
  }
});

authApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default authApi;
